import Vue from 'vue'

// 注册一个全局自定义指令 `v-focus`
Vue.directive('textareafocus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
        let innerHtml = el.getElementsByTagName('textarea')[0]
        // 聚焦元素
        innerHtml.focus()
    }
})
Vue.directive('inputfocus', {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function (el) {
        let innerHtml = el.getElementsByTagName('input')[0]
        // 聚焦元素
        innerHtml.focus()
    }
})
  


// WEBPACK FOOTER //
// ./src/util/dire.js